import React, { useEffect, useRef } from 'react';
import { SearchWrapper, SearchIconSlot, SearchInput, ShortcutHint } from './searchBar.styles';

const SearchIcon = () => (
  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="7" />
    <path strokeLinecap="round" d="m21 21-4.3-4.3" />
  </svg>
);

/**
 * Reusable search input — controlled component that renders a leading
 * search icon and an optional trailing keyboard-shortcut hint (e.g. ⌘K)
 * that focuses the input when pressed.
 */
const SearchBar = ({
  value,
  onChange,
  placeholder = 'Search…',
  shortcut = '⌘K',
  ariaLabel = 'Search',
  ...rest
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!shortcut) return undefined;

    const handleKeyDown = (event) => {
      const isShortcut = (event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k';
      if (isShortcut) {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shortcut]);

  return (
    <SearchWrapper>
      <SearchIconSlot>
        <SearchIcon />
      </SearchIconSlot>
      <SearchInput
        ref={inputRef}
        type="search"
        value={value}
        onChange={(event) => onChange?.(event.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        {...rest}
      />
      {shortcut && <ShortcutHint>{shortcut}</ShortcutHint>}
    </SearchWrapper>
  );
};

export default SearchBar;
